import React from "react";
import { Grid, Typography } from "@mui/material";

/**
 * @param {{ fields: Array<{ label: string, value: string }> }} props
 */
export default function DetailFieldGrid({ fields }) {
  if (!fields?.length) return null;

  return (
    <Grid container spacing={2}>
      {fields.map((field) => (
        <Grid item xs={12} sm={6} key={field.label}>
          <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
            {field.label}
          </Typography>
          <Typography variant="body2" sx={{ wordBreak: "break-word" }}>
            {field.value}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
}
